<template>
  <div>
    <VBtn
      ref="toggleUserList"
      v-bind="btnBind"
    >
      {{ toggleUserListBtnText }}
      <VIcon
        v-if="!hideChevron"
        v-text="isUserListOpen ? 'mdi-chevron-up' : 'mdi-chevron-down'"
      />
    </VBtn>
    <VBtn
      ref="toggleAllUsersBtn"
      class="ml-2"
      @click="toggleAllUsers(sortedFilteredUsers)"
    >
      {{ selectAction }}
    </VBtn>
    <div
      v-if="isUserListOpen"
      ref="userList"
      style="position: absolute; z-index: 1000; overflow-y: scroll; max-height: 600px;"
    >
      <VTextField
        v-if="allUsers && allUsers.length > 1"
        v-model="quickFilter"
        placeholder="Поиск пользователя"
        outlined
        dense
        hide-details
        class="white mb-0 quick-filter"
      />
      <VList dense>
        <VListItem
          v-for="user in sortedFilteredUsers"
          :key="user.id"
          @click="toggleUser(user.id)"
        >
          <VIcon
            left
            color="primary"
          >
            {{ value.includes(user.id)
              ? 'mdi-check-box-outline'
              : 'mdi-checkbox-blank-outline' }}
          </VIcon>
          {{ $store.getters['user/displayName'](user.id) }}
        </VListItem>
      </VList>
    </div>
  </div>
</template>

<script>
import * as R from 'ramda'

export default {
  name: 'UserSelector',
  inheritAttrs: false,
  props: {
    value: {
      type: Array,
      default: () => [],
      validate: value =>
        Array.isArray(value) && value.every(x => Number.isInteger(x)),
    },
    placeholder: { type: String, default: 'Выберите пользователей' },
    // Отобразить в селекторе только самого пользователя и его подчиненных
    limitToRelevant: { type: Boolean, default: true },
    // Скрыть шеврон-стрелочку на кнопке
    hideChevron: { type: Boolean, default: false },
    // Скрыть шеврон-стрелочку на кнопке
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      isUserListOpen: false,
      quickFilter: '',
    }
  },
  computed: {
    selectAction() {
      return this.value.length === 0 ? 'Выбрать всех' : 'Убрать всех'
    },
    btnBind() {
      const { $attrs, disabled } = this
      return { color: 'primary', ...$attrs, disabled }
    },
    allUsers() {
      const { $store, limitToRelevant } = this
      return $store
        .getters[limitToRelevant ? 'user/relevant' : 'user/list']
    },
    filteredUsers() {
      const { $store, allUsers, quickFilter } = this
      const tokens = quickFilter
        .split(/\s+/)
        .filter(Boolean)
        .map(R.toLower)
      if (allUsers && tokens.length) {
        return allUsers.filter(user => {
          const searchIn = [
            String(user.id),
            user.username.toLowerCase(),
            $store.getters['user/displayName'](user.id).toLowerCase(),
          ]
          return tokens.every(tok => searchIn.some(f => f.includes(tok)))
        })
      }
      return allUsers
    },
    sortedFilteredUsers() {
      const { $store, filteredUsers: users } = this
      return users && R.sortBy(user => {
        const name = $store.getters['user/displayName'](user.id)
        return `${name}`
      })(users)
    },
    toggleUserListBtnText() {
      const { $store, value, placeholder } = this
      if (value.length === 0) return placeholder
      const firstUserName = $store.getters['user/displayName'](value[0])
      return value.length === 1
        ? firstUserName
        : `${firstUserName} + ${value.length - 1}`
    },
  },
  watch: {
    isUserListOpen(isUserListOpen) {
      if (!isUserListOpen) {
        this.quickFilter = ''
      }
    },
  },
  mounted() {
    document.addEventListener('mousedown', this.checkUserListOpen)
  },
  beforeDestroy() {
    document.removeEventListener('mousedown', this.checkUserListOpen)
  },
  methods: {
    eventHitsRefElement(event, ref) {
      if (ref === undefined) {
        return false
      } else {
        if (ref instanceof Element) {
          return ref.contains(event.target)
        } else {
          if (ref.$el !== undefined) {
            return ref.$el.contains(event.target)
          } else {
            return false
          }
        }
      }
    },
    eventHitsRefElements(event, refs) {
      return refs.some((ref) => this.eventHitsRefElement(event, ref))
    },
    checkUserListOpen(event) {
      const userList = this.$refs.userList
      const toggleUserList = this.$refs.toggleUserList
      const toggleAllUsersBtn = this.$refs.toggleAllUsersBtn
      if (this.eventHitsRefElement(event, toggleUserList)) {
        this.isUserListOpen = !this.isUserListOpen
      } else {
        const notCloseOnHitRefs = [userList, toggleAllUsersBtn]
        if (!this.eventHitsRefElements(event, notCloseOnHitRefs)) {
          this.isUserListOpen = false
        }
      }
    },
    toggleUser(userId) {
      const { value } = this
      // dropAll(1)([ 1, 1, 2, 1, 3, 1, 1 ]) // => [ 2, 3 ]
      const dropAll = x => R.filter(R.complement(R.equals(x)))
      const newValue = R.pipe(
        R.ifElse( // 1. add or remove userId from value
          R.includes(userId), // condition
          dropAll(userId), // onTrue
          R.append(userId), // onFalse
        ),
        R.sortBy(R.identity), // 2. sort value
      )(value)
      this.$emit('input', newValue)
    },
    toggleAllUsers(users) {
      const { value } = this
      const newValue = []
      if (value.length === 0) {
        users.map(user => {
          newValue.push(user.id)
          return user.id
        })
      }
      this.$emit('input', newValue)
    },
  },
}
</script>

<style lang="sass" scoped>
  .quick-filter
    position: sticky
    top: 0
    left: 5px
    right: 5px
    z-index: 2
</style>
